import { render, staticRenderFns } from "./RecepcionCaptura.vue?vue&type=template&id=9e6e4db8&"
import script from "./RecepcionCaptura.vue?vue&type=script&lang=js&"
export * from "./RecepcionCaptura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports